<app-page-title icon="fa-microphone" title="Novo Áudio">
  <a [routerLink]="['/call4u-audios']" class="btn btn-secondary">
    <i class="fa fa-arrow-left"></i> Voltar
  </a>
</app-page-title>

<form (submit)="saveUpload()">

  <!-- Informações do Áudio -->
  <div class="card elevated mb-3">
    <div class="card-body">
      <h3><span>1</span><p>Informações do Áudio</p></h3>

      <div class="row">
        <div class="col-md-6 col-sm-12">
          <div class="form-group">
            <label for="title">Título</label>
            <input
              type="text"
              id="title"
              class="form-control"
              [(ngModel)]="title"
              name="title"
              placeholder="Ex: Áudio de boas-vindas"
              maxlength="255"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label for="text">Texto do Áudio</label>
            <textarea
              id="text"
              class="form-control"
              [(ngModel)]="text"
              name="text"
              rows="4"
              placeholder="Descrição ou texto de referência do áudio"
              maxlength="5000"
            ></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Enviar Áudio -->
  <div class="card elevated mb-3">
    <div class="card-body">
      <h3><span>2</span><p>Enviar Áudio</p></h3>

      <div class="row">
        <!-- Upload compacto -->
        <div class="col-md-8 col-sm-12">
          <div class="upload-compact" *ngIf="!selectedFile">
            <input
              type="file"
              id="audioFile"
              class="d-none"
              accept=".mp3,.wav,.ogg,.m4a"
              (change)="onFileSelected($event)"
            />
            <label for="audioFile" class="upload-compact-label">
              <i class="fa fa-cloud-upload"></i>
              <span>Selecionar arquivo de áudio</span>
              <small>MP3, WAV, OGG, M4A (máx. 10MB, até 30s)</small>
            </label>
          </div>

          <div class="selected-file" *ngIf="selectedFile">
            <div class="d-flex align-items-center gap-3">
              <i class="fa fa-file-audio-o fa-lg"></i>
              <div class="flex-grow-1">
                <strong>{{ fileName }}</strong>
                <small class="d-block">{{ (selectedFile.size / 1024 / 1024).toFixed(2) }} MB</small>
              </div>
              <button type="button" class="btn btn-sm btn-danger" (click)="removeFile()">
                <i class="fa fa-times"></i>
              </button>
            </div>
            <div *ngIf="fileDurationError" class="alert alert-danger mt-2 mb-0 py-2" style="font-size: 0.85rem;">
              <i class="fa fa-exclamation-triangle me-1"></i>
              O áudio excede o limite máximo de 30 segundos. Envie um arquivo mais curto.
            </div>
          </div>
        </div>

        <!-- Botão TTS -->
        <div class="col-md-4 col-sm-12">
          <button
            type="button"
            class="btn-tts-generate"
            (click)="openTtsModal(modalTts, modalNoCredits)"
          >
            <i class="fa fa-magic"></i>
            <span>Gerar Áudio Automaticamente</span>
            <small>Inteligência Artificial (TTS)</small>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Ações DTMF -->
  <div class="card elevated mb-3">
    <div class="card-body">
      <div class="d-flex justify-content-between align-items-start mb-3">
        <h3 class="mb-0"><span>3</span><p>Ações por Dígito <small style="font-size: 0.7rem; text-transform: none; color: #9aa2a8;">(opcional)</small></p></h3>
        <button
          type="button"
          class="btn btn-primary btn-sm"
          (click)="addAction()"
          [disabled]="dtmfActions.length >= 14"
        >
          <i class="fa fa-plus me-1"></i> Adicionar
        </button>
      </div>

      <small class="d-block mb-3" style="color: #9aa2a8;">
        Configure ações que serão executadas quando o lead pressionar uma tecla durante a ligação
      </small>

      <!-- Vazio -->
      <div *ngIf="dtmfActions.length === 0" class="empty-actions">
        <i class="fa fa-keyboard-o fa-2x"></i>
        <p>Nenhuma ação configurada</p>
        <small>Clique em "Adicionar" para definir ações por tecla</small>
      </div>

      <!-- Ações -->
      <div *ngFor="let action of dtmfActions; let i = index" class="action-row mb-2">
        <div class="row align-items-end">
          <div class="col-md-2 col-sm-3">
            <div class="form-group mb-0">
              <label>Opção</label>
              <select class="form-control" [(ngModel)]="action.dtmf_key" [name]="'dtmf_key_' + i">
                <option value="" disabled>--</option>
                <option *ngFor="let key of getAvailableKeys(i)" [value]="key.key">{{ key.label }}</option>
              </select>
            </div>
          </div>

          <div class="col-md-3 col-sm-9">
            <div class="form-group mb-0">
              <label>Ação</label>
              <select class="form-control" [(ngModel)]="action.action_type" [name]="'action_type_' + i">
                <option value="" disabled>Selecione a ação</option>
                <option *ngFor="let at of actionTypes" [value]="at.value">{{ at.label }}</option>
              </select>
            </div>
          </div>

          <div class="col-md-5 col-sm-10" *ngIf="needsTextParam(action.action_type)">
            <div class="form-group mb-0">
              <label>{{ getParamLabel(action.action_type) }}</label>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="action.action_text"
                [name]="'action_text_' + i"
                [placeholder]="getParamPlaceholder(action.action_type)"
              />
            </div>
          </div>

          <div class="col-md-5 col-sm-10" *ngIf="needsListParam(action.action_type)">
            <div class="form-group mb-0">
              <label>Lista</label>
              <select
                class="form-control"
                [(ngModel)]="action.action_list_id"
                [name]="'action_list_' + i"
              >
                <option value="" disabled>Selecione uma lista</option>
                <option *ngFor="let list of lists" [value]="list.id">{{ list.name }}</option>
              </select>
            </div>
          </div>

          <div class="col-md-2 col-sm-2">
            <button type="button" class="btn btn-sm btn-danger" (click)="removeAction(i)" title="Remover">
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Upload Progress -->
  <div class="mb-3" *ngIf="uploading">
    <div class="d-flex justify-content-between mb-1">
      <small class="text-muted">Enviando audio...</small>
      <small class="text-muted">{{ uploadProgress }}%</small>
    </div>
    <div class="progress" style="height: 8px;">
      <div
        class="progress-bar progress-bar-striped progress-bar-animated"
        role="progressbar"
        [style.width.%]="uploadProgress"
        [attr.aria-valuenow]="uploadProgress"
        aria-valuemin="0"
        aria-valuemax="100"
      ></div>
    </div>
  </div>

  <!-- Botões -->
  <div class="mb-4">
    <!-- O envio do arquivo tem barra de progresso logo acima, que diz mais que
         um giro: por isso o botão carrega por `saving`, não por `uploading`. -->
    <button
      type="submit"
      class="btn btn-primary me-2"
      [appLoadingButton]="saving"
      [disabled]="!isUploadFormValid || uploading"
    >
      <i class="fa fa-check me-1"></i>
      Salvar Áudio
    </button>
    <a [routerLink]="['/call4u-audios']" class="btn btn-secondary">Cancelar</a>
  </div>
</form>

<!-- Modal TTS -->
<ng-template #modalTts let-modal>
  <div class="modal-header">
    <h4 class="modal-title">
      <i class="fa fa-magic me-2"></i>Gerar Áudio Automaticamente
    </h4>
    <button type="button" class="btn-close" aria-label="Fechar" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <!-- Steps indicator -->
    <div class="steps-indicator mb-4">
      <div class="step-item" [class.active]="ttsStep >= 1" [class.current]="ttsStep === 1">
        <div class="step-number">1</div>
        <div class="step-label">Informações</div>
      </div>
      <div class="step-line" [class.active]="ttsStep >= 2"></div>
      <div class="step-item" [class.active]="ttsStep >= 2" [class.current]="ttsStep === 2">
        <div class="step-number">2</div>
        <div class="step-label">Voz</div>
      </div>
      <div class="step-line" [class.active]="ttsStep >= 3"></div>
      <div class="step-item" [class.active]="ttsStep >= 3" [class.current]="ttsStep === 3">
        <div class="step-number">3</div>
        <div class="step-label">Resumo</div>
      </div>
    </div>

    <!-- Step 1: Informações -->
    <div *ngIf="ttsStep === 1">
      <h5 class="step-title">Informações do Áudio</h5>

      <div class="form-group mb-3">
        <label for="ttsTitle">Título</label>
        <input
          type="text"
          id="ttsTitle"
          class="form-control"
          [(ngModel)]="ttsTitle"
          name="ttsTitle"
          placeholder="Nome para identificar o áudio"
          maxlength="255"
        />
      </div>

      <div class="form-group">
        <label for="ttsTextInput">Texto do Áudio</label>
        <textarea
          id="ttsTextInput"
          class="form-control"
          [(ngModel)]="ttsText"
          name="ttsTextInput"
          rows="6"
          maxlength="5000"
          placeholder="Digite o texto que será convertido em voz pela inteligência artificial..."
        ></textarea>
        <div class="d-flex justify-content-end mt-1">
          <small [style.color]="ttsText.length > 4500 ? '#FD5B8D' : '#9aa2a8'">
            {{ ttsText.length }}/5000
          </small>
        </div>
      </div>
    </div>

    <!-- Step 2: Seleção de Voz -->
    <div *ngIf="ttsStep === 2">
      <h5 class="step-title">Seleção de Voz</h5>

      <div class="form-group">
        <label for="ttsVoice">Escolha a voz</label>
        <select
          id="ttsVoice"
          class="form-control"
          [(ngModel)]="ttsVoiceId"
          name="ttsVoice"
        >
          <option *ngFor="let voice of voices" [value]="voice.id">
            {{ voice.name }}
          </option>
        </select>
      </div>

      <div class="voice-list mt-3">
        <div
          *ngFor="let voice of voices"
          class="voice-option"
          [class.selected]="ttsVoiceId === voice.id"
          (click)="ttsVoiceId = voice.id"
        >
          <i class="fa" [ngClass]="ttsVoiceId === voice.id ? 'fa-check-circle' : 'fa-circle-o'"></i>
          <span>{{ voice.name }}</span>
        </div>
      </div>
    </div>

    <!-- Step 3: Resumo e Preview -->
    <div *ngIf="ttsStep === 3">
      <h5 class="step-title">Resumo e Preview</h5>

      <div class="summary-card">
        <div class="summary-row">
          <label>Título:</label>
          <span>{{ ttsTitle }}</span>
        </div>
        <div class="summary-row">
          <label>Texto:</label>
          <span class="summary-text">{{ ttsText }}</span>
        </div>
        <div class="summary-row">
          <label>Voz:</label>
          <span>{{ getVoiceName(ttsVoiceId) }}</span>
        </div>
      </div>

      <!-- Preview TTS -->
      <div class="preview-section mt-3">
        <div class="d-flex align-items-center gap-2 mb-2">
          <button
            type="button"
            class="btn btn-outline-primary btn-sm"
            (click)="generatePreview()"
            [appLoadingButton]="ttsPreviewLoading"
          >
            <i class="fa fa-headphones me-1"></i>
            Ouvir Preview
          </button>

          <span class="text-muted" style="font-size: 0.85rem;" *ngIf="!ttsPreviewUrl && !ttsPreviewLoading">
            Ouça o áudio antes de salvar
          </span>
        </div>

        <!-- Player do Preview -->
        <div *ngIf="ttsPreviewUrl" class="preview-player d-flex align-items-center gap-3 p-2 rounded" style="background: #f8f9fa; border: 1px solid #dee2e6;">
          <button
            type="button"
            class="btn btn-sm"
            [ngClass]="ttsPreviewPlaying ? 'btn-danger' : 'btn-primary'"
            (click)="toggleTtsPreview()"
          >
            <i class="fa" [ngClass]="ttsPreviewPlaying ? 'fa-pause' : 'fa-play'"></i>
          </button>

          <div class="flex-grow-1">
            <small class="d-block"><strong>Preview do áudio</strong></small>
            <small [style.color]="isTtsOverDuration ? '#FD5B8D' : ''">
              Duração: {{ formatPreviewDuration(ttsPreviewDuration) }}
              <span *ngIf="isTtsOverDuration"> (excede o limite de 30s)</span>
            </small>
          </div>

          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            (click)="generatePreview()"
            [appLoadingButton]="ttsPreviewLoading"
            title="Regenerar preview"
          >
            <i class="fa fa-refresh"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer d-flex justify-content-between">
    <div>
      <button
        type="button"
        class="btn btn-secondary"
        *ngIf="ttsStep > 1"
        (click)="prevStep()"
      >
        <i class="fa fa-arrow-left me-1"></i> Voltar
      </button>
    </div>
    <div>
      <button
        type="button"
        class="btn btn-secondary me-2"
        (click)="modal.dismiss()"
      >
        Cancelar
      </button>

      <button
        type="button"
        class="btn btn-primary"
        *ngIf="ttsStep < 3"
        [disabled]="(ttsStep === 1 && !isTtsStep1Valid) || (ttsStep === 2 && !isTtsStep2Valid)"
        (click)="nextStep()"
      >
        Próximo <i class="fa fa-arrow-right ms-1"></i>
      </button>

      <button
        type="button"
        class="btn btn-primary"
        *ngIf="ttsStep === 3"
        [appLoadingButton]="ttsSaving"
        [disabled]="isTtsOverDuration"
        (click)="saveTts(modal)"
      >
        <i class="fa fa-magic me-1"></i>
        Gerar Áudio
      </button>
    </div>
  </div>
</ng-template>

<!-- Modal Sem Créditos -->
<ng-template #modalNoCredits let-modal>
  <div class="modal-header">
    <h4 class="modal-title" data-testid="tts-no-funds-title">
      <i class="fa fa-exclamation-triangle me-2 text-warning"></i>{{ callBilledByWallet ? 'Sem saldo na carteira' : 'Sem créditos de ligação' }}
    </h4>
    <button type="button" class="btn-close" aria-label="Fechar" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p class="mb-0" *ngIf="!callBilledByWallet">
      Você não possui créditos de ligação para gerar áudios com Inteligência Artificial (TTS).
      Recarregue agora para continuar.
    </p>
    <!-- T.9: a ligação desta conta sai da carteira em R$; não há pacote de ligação para comprar. -->
    <p class="mb-0" *ngIf="callBilledByWallet" data-testid="tts-no-wallet-balance">
      Você não possui saldo na carteira para gerar áudios com Inteligência Artificial (TTS).
      Adicione saldo para continuar.
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="sf-btn sf-btn--secondary" (click)="modal.dismiss()">Fechar</button>
    <a class="sf-btn sf-btn--primary" *ngIf="!callBilledByWallet" routerLink="/recharges/new" [queryParams]="{target: 'call'}"
      (click)="modal.close()" data-testid="tts-recharge-package">
      <i class="fa fa-plus me-1"></i> Recarregar
    </a>
    <a class="sf-btn sf-btn--primary" *ngIf="callBilledByWallet" routerLink="/wallet" [queryParams]="{ recarga: 1 }"
      (click)="modal.close()" data-testid="tts-recharge-wallet">
      <i class="fa fa-plus me-1"></i> Adicionar saldo
    </a>
  </div>
</ng-template>
